module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_integration01-596af587fbbb4ba15d7a2e6a1780846e.png";